import { render } from "./RegisterUserModal.vue?vue&type=template&id=6160bc38&scoped=true"
import script from "./RegisterUserModal.vue?vue&type=script&lang=js"
export * from "./RegisterUserModal.vue?vue&type=script&lang=js"

import "./RegisterUserModal.vue?vue&type=style&index=0&id=6160bc38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6160bc38"]])

export default __exports__